import { activate, create, getById, remove, update } from '@/services/api';

const Model = {
  namespace: 'sites',
  state: {
    showForm: false,
    formDetail: false,
    formId: null,
    formItem: null,
    formLoading: false,
    formSuccess: false,
    newSite: false,
    activatingItemIds: {},
  },

  effects: {
    *showForm({ payload }, { put }) {
      yield put({ type: 'queryShowForm', payload });
      if (payload?.state && payload?.id) {
        yield put({ type: 'fetchSiteItem', payload: { id: payload.id } });
      }
    },

    *saveNewSite({ payload }, { call, put }) {
      try {
        const res = yield call(create, { route: 'site', data: payload });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'queryNewSite', payload: false });
        return res;
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: { visible: true, type: 'error', message: error.message },
            validationErrors: error.validationErrors,
          });
        }
        return null;
      }
    },

    *fetchSiteItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'queryFormLoading', payload: true });
        const response = yield call(getById, {
          id: payload.id,
          route: 'site',
          select:
            'id,name,description,kind,isActive,slug,publicHost,publicCode,created,updated,creator,modifier',
        });
        const item = response.data || response;
        yield put({ type: 'queryFormItem', payload: item });
      } catch (e) {
        yield put({ type: 'queryFormLoading', payload: false });
      }
    },

    *updateSiteItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'queryFormLoading', payload: true });
        yield call(update, { route: 'site', data: { ...payload, id: payload.id } });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'queryFormSuccess' });
        yield put({
          type: 'queryShowForm',
          payload: { state: false, id: null, item: null, detail: false },
        });
      } catch (e) {
        yield put({ type: 'queryFormLoading', payload: false });
        if (e?.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: { visible: true, type: 'error', message: e.message },
            validationErrors: e.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params }, { call, put }) {
      try {
        yield put({ type: 'global/modalConfirm', state: false, id: null });
        yield call(remove, { id, route: 'site' });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        yield put({ type: 'global/modalConfirm', state: false, id: null });
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    *editActive({ payload }, { call, put, select }) {
      const { id } = payload || {};
      if (!id) return;
      const already = yield select((s) => s.sites?.activatingItemIds?.[id]);
      if (already) return;
      yield put({ type: 'queryActivatingItem', payload: { id, active: true } });
      try {
        yield call(activate, { id, route: 'site', isActive: payload.isActive });
        yield put({
          type: 'launchpad/syncItemActive',
          payload: { type: 'sites', id, isActive: payload.isActive },
        });
      } catch (e) {
      } finally {
        yield put({ type: 'queryActivatingItem', payload: { id, active: false } });
      }
    },
  },

  reducers: {
    addNewSite(state, { payload }) {
      return { ...state, newSite: !!payload?.state };
    },
    queryNewSite(state, { payload }) {
      return { ...state, newSite: payload };
    },
    queryShowForm(state, { payload }) {
      return {
        ...state,
        showForm: !!payload?.state,
        formDetail: !!payload?.detail,
        formId: payload?.id || null,
        formItem: payload?.item || null,
        formLoading: false,
      };
    },
    queryFormLoading(state, { payload }) {
      return { ...state, formLoading: payload };
    },
    queryFormItem(state, { payload }) {
      return { ...state, formItem: payload, formLoading: false };
    },
    queryFormSuccess(state) {
      return { ...state, formSuccess: true, formLoading: false };
    },
    clearFormSuccess(state) {
      return { ...state, formSuccess: false };
    },
    queryActivatingItem(state, { payload }) {
      const { id, active } = payload || {};
      if (!id) return state;
      return {
        ...state,
        activatingItemIds: { ...state.activatingItemIds, [id]: !!active },
      };
    },
  },
};

export default Model;
